
export class UserProfile {
    firstName!: string;
    lastName!: string;
    email!: string;
    currency!: string;
    defaultArtistName!: string;
    defaultWriterName!: string;
    defaultPublisherName!: string;
    defaultAka!: string;
    defaultLabel!: string;
    dateFormat!: string;
    timeFormat!: string;
    timeZone!: string;
    iPINumber!: string;
    affiliation!: string | null | undefined | object;
    image!: string;
    telephone!: string;
    address!: string;
    street!: string;
    city!: string;
    state!: string;
    country!: string;
    zip_code!: string;
}
